import { render, staticRenderFns } from "./Commercial.vue?vue&type=template&id=4a2df568&"
import script from "./Commercial.vue?vue&type=script&lang=js&"
export * from "./Commercial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports